"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgPendingSecondary = function SvgPendingSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M27.66 19.19c-1.84 6.43-8.541 10.153-14.973 8.32-6.432-1.832-10.164-8.528-8.34-14.962C6.173 6.114 12.865 2.374 19.3 4.19c.533.15 1.054.336 1.56.56.46.194.994.04 1.28-.37a1.09 1.09 0 00-.44-1.62 13.41 13.41 0 00-6.88-1.06 14.52 14.52 0 00-12.45 9.85 14.3 14.3 0 1027.79 2.35 1.1 1.1 0 00-1.73-.7 1.11 1.11 0 00-.42 1c.24 1.67.12 3.37-.35 4.99z" }),
            _react2.default.createElement("path", { d: "M22.4 15.48h-6.08V11a1.57 1.57 0 00-3.13 0v6.15c.002.376.153.735.42 1 .268.26.626.407 1 .41h7.79a1.57 1.57 0 000-3.13v.05z" })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgPendingSecondary);